//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import numeral from 'numeral'

export default {
  name: 'PaymentAmount',

  data() {
    return {
      type: 'invoice', //custom or invoice
      invoices: [
        { id: 1, amount: 1000, is_selected: false },
        { id: 2, amount: 2000, is_selected: false },
        { id: 3, amount: 3400, is_selected: false }
      ]
    }
  },

  computed: {
    totalAmount() {
      const total = this.totalAmountCalculation
      return this.formatAmount(total)
    },

    totalAmountCalculation() {
      const selectedInvoices = this.invoices.filter(
        invoice => invoice.is_selected
      )

      return selectedInvoices.length
        ? selectedInvoices.reduce((total, invoice) => total + invoice.amount, 0)
        : 0
    },

    isTypeCustom() {
      return this.type === 'custom'
    },

    isTypeInvoice() {
      return this.type === 'invoice'
    }
  },

  methods: {
    toggleInvoice(invoice) {
      invoice.is_selected = !invoice.is_selected
    },

    formatAmount(amount) {
      return numeral(amount).format('$0,0')
    },

    changeTypeToCustom() {
      this.type = 'custom'
    },

    changeTypeToInvoice() {
      this.type = 'invoice'
    }
  }
}
